var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-12",attrs:{"fluid":""}},[_c('v-col',{attrs:{"cols":"auto pa-0 wrapper-container"}},[_c('div',{staticClass:"mb-4 view-headline color text-navigation font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t('partnerIntegrations.title'))+" ")]),_c('PartnerIntegrations')],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }